import { Outlet } from "@tanstack/react-router";

import LayoutDeterminer from "@/components/Layout/LayoutDeterminer";
import { AnalyticsRouterTracker } from "@/providers/Analytics";
import AuthProvider from "@/providers/Auth";

export const RootRoute = () => {
  return (
    <AuthProvider>
      <LayoutDeterminer>
        <AnalyticsRouterTracker />
        <Outlet />
      </LayoutDeterminer>
    </AuthProvider>
  );
};

export default RootRoute;
